<template>
  <div class="box table-info">
    <database-not-found
      v-if="noData"
      class="table-info"
    />
    <div v-else>
      <b-table
        :sticky-header="true"
        :centered="true"
        :data="tableRow"
        :columns="tableHeader"
        :hoverable="true"
        :striped="true"
        :height="500"
      >
      </b-table>
      <b-table><template #footer>
          <th class="has-text-left">Success Order</th>
          <th>{{sumSuccessOrder}}</th>
          <th>Order(s)</th>
        </template></b-table>
    </div>
  </div>
</template>
<script>
import DatabaseNotFound from '../components/etc/DatabaseNotFound.vue'
export default {
  name: 'TableInfo',
  components: { DatabaseNotFound },
  props: ['tableData'],
  data () {
    return {
      headerLabel: ['Branch', 'On-time', 'Late', '(%) On-time'],
      header: [
        {
          field: 'id',
          label: 'Driver Name',
          centered: true
        },
        {
          field: 'delivered',
          label: 'Delivered',
          numeric: true,
          centered: true
        },
        {
          field: 'percent',
          label: 'Percent On-Time',
          centered: true
        }
      ],
      data: [
        { id: 'aa', delivered: 1, percent: 100 },
        { id: 'aa', delivered: 1, percent: 100 },
        { id: 'aa', delivered: 1, percent: 100 },
        { id: 'aa', delivered: 1, percent: 100 }
      ],
      sumSuccessOrder: 0,
      noData: false
    }
  },
  watch: {
    tableData: {
      handler (val) {
        if (val.source.length) {
          try {
            this.sumSuccessOrder = 0
            this.noData = false
          } catch (error) {
            // console.log('error', error)
          }
        } else {
          this.noData = true
        }
      }
    }
    // nodata () {
    //   if (this.nodata) {
    //     this.noData = true
    //   } else { this.noData = false }
    // }
  },
  computed: {
    // nodata () {
    //   return this.$store.getters['summary/haveNoData']
    // },
    tableHeader () {
      const header = []
      this.tableData.dimensions.forEach((i, index) => {
        header.push({
          field: i,
          label: this.headerLabel[index],
          centered: true
        })
      })
      header.splice(1, 0, {
        field: 'delivered',
        label: 'Delivered',
        centered: true
      })
      return header
    },
    tableRow () {
      const data = []
      this.tableData.sourceDer.forEach((item) => {
        const temp = {}
        item.forEach((i, index) => {
          temp[`${this.tableHeader[index].field}`] = i
        })
        this.sumSuccessOrder += temp.delivered
        data.push(temp)
      })
      data.sort((a, b) => b.percentOn - a.percentOn)
      // console.log(data)
      return data
    }
  }
}
</script>

<style>
.table-info {
  width: 100%;
  height: 600px;
}
</style>
